import {
  ApiResponse,
  CreateQueueAgentsApiArg,
  CreateQueueApiArg,
  CreateQueueApiResponse,
  CreateQueueTeamsApiArg,
  DeleteQueueAgentsApiArg,
  DeleteQueueTeamApiArg,
  PatchQueueAgentApiArg,
  PatchQueueApiArg,
  PatchQueueTeamApiArg,
  ReadQueueApiArg,
  ReadQueueApiResponse,
  UpdateQueueApiArg,
  UpdateQueueApiResponse,
} from 'lib-shared-types-api';

import { api } from 'app/app.api';

export const queuesApi = api
  .enhanceEndpoints({
    addTagTypes: ['Queue'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      createQueue: builder.mutation<CreateQueueApiResponse, CreateQueueApiArg>({
        query: ({ queue }) => ({
          version: 2,
          path: 'queues',
          method: 'POST',
          body: queue,
        }),
      }),
      readQueue: builder.query<ReadQueueApiResponse, ReadQueueApiArg>({
        query: ({ id }) => ({
          version: 2,
          path: `queues/${id}`,
        }),
        providesTags: (_result, _error, arg) => [{ type: 'Queue', id: arg.id }],
      }),
      updateQueue: builder.mutation<UpdateQueueApiResponse, UpdateQueueApiArg>({
        query: ({ id, queue }) => ({
          version: 3,
          path: `queues/${id}`,
          method: 'PUT',
          body: queue,
        }),
        invalidatesTags: (_result, _error, arg) => [
          { type: 'Queue', id: arg.id },
        ],
      }),
      patchQueue: builder.mutation<UpdateQueueApiResponse, PatchQueueApiArg>({
        query: ({ id, queue }) => ({
          version: 3,
          path: `queues/${id}`,
          method: 'PATCH',
          body: queue,
        }),
        invalidatesTags: (_result, _error, arg) => [
          { type: 'Queue', id: arg.id },
        ],
      }),
      createQueueAgents: builder.mutation<ApiResponse, CreateQueueAgentsApiArg>(
        {
          query: ({ id, ...body }) => ({
            version: 2,
            path: `queues/${id}/agents`,
            method: 'PUT',
            body,
          }),
        },
      ),
      patchQueueAgent: builder.mutation<ApiResponse, PatchQueueAgentApiArg>({
        query: ({ agentId, id, ...body }) => ({
          version: 3,
          path: `queues/${id}/agents/${agentId}`,
          method: 'PATCH',
          body,
        }),
      }),
      deleteQueueAgents: builder.mutation<ApiResponse, DeleteQueueAgentsApiArg>(
        {
          query: ({ id, agentIds: agents }) => ({
            version: 2,
            path: `queues/${id}/agents`,
            method: 'DELETE',
            body: { agents },
          }),
        },
      ),
      createQueueTeams: builder.mutation<ApiResponse, CreateQueueTeamsApiArg>({
        query: ({ id, ...body }) => ({
          version: 2,
          path: `queues/${id}/teams`,
          method: 'PUT',
          body,
        }),
      }),
      patchQueueTeam: builder.mutation<ApiResponse, PatchQueueTeamApiArg>({
        query: ({ teamId, id, ...body }) => ({
          version: 3,
          path: `queues/${id}/teams/${teamId}`,
          method: 'PATCH',
          body,
        }),
      }),
      deleteQueueTeam: builder.mutation<ApiResponse, DeleteQueueTeamApiArg>({
        query: ({ id, teamId }) => ({
          version: 2,
          path: `queues/${id}/teams/${teamId}`,
          method: 'DELETE',
        }),
      }),
    }),
  });
